// src/Components/modules/Traslados/PaginacionTrasladosAnt.js

import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Pagination, Select } from "antd";

const { Option } = Select;

/**
 * Componente de paginación para traslados, siguiendo el mismo diseño que en el módulo
 * de Coordinación, con el selector de filas por página a la izquierda y la paginación a la derecha.
 *
 * Se espera que "page" sea 0-based en el estado, por lo que se convierte a 1-based para el
 * componente Pagination y viceversa en el handler.
 */
const PaginacionTrasladosAnt = ({
  page, // Página actual (0-based, ej. 0 para la 1ª página)
  rowsPerPage,
  count,
  totalAbsoluto, // Total absoluto sin filtros (opcional)
  onPageChange, // Función con la firma: (event, newPage)
  onRowsPerPageChange, // Función con la firma: (event)
}) => {
  // Handler para cambiar la página (recibe currentPage 1-based)
  const handlePageChange = (currentPage) => {
    // Convertir a 0-based y llamar al handler recibido
    onPageChange(null, currentPage - 1);
  };

  // Handler para cambiar la cantidad de filas por página
  const handleItemsPerPageChange = (value) => {
    onRowsPerPageChange({ target: { value } });
  };

  return (
    <Row
      justify="space-between"
      align="middle"
      style={{ padding: "16px", backgroundColor: "#ffffff" }}
    >
      <Col>
        <Select
          value={rowsPerPage}
          onChange={handleItemsPerPageChange}
          style={{ width: 120 }}
          size="middle"
        >
          <Option value={10}>10 / página</Option>
          <Option value={25}>25 / página</Option>
          <Option value={50}>50 / página</Option>
          <Option value={100}>100 / página</Option>
        </Select>
      </Col>

      <Col>
        <Pagination
          current={page + 1} // Convertir de 0-based a 1-based
          pageSize={rowsPerPage}
          total={count}
          onChange={handlePageChange}
          showSizeChanger={false}
          showTotal={(total) => 
            totalAbsoluto && totalAbsoluto !== total 
              ? `Total ${total} traslados de ${totalAbsoluto}` 
              : `Total ${total} traslados`
          }
        />
      </Col>
    </Row>
  );
};

PaginacionTrasladosAnt.propTypes = {
  page: PropTypes.number.isRequired, // Página actual (0-based)
  rowsPerPage: PropTypes.number.isRequired, // Cantidad de filas por página
  count: PropTypes.number.isRequired, // Total de traslados filtrados
  totalAbsoluto: PropTypes.number, // Total absoluto sin filtros (opcional)
  onPageChange: PropTypes.func.isRequired, // Función para cambiar página
  onRowsPerPageChange: PropTypes.func.isRequired, // Función para cambiar filas/página
};

export default PaginacionTrasladosAnt;
